export const Menu = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="#1F1F1F" xmlns="http://www.w3.org/2000/svg">
        <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"></path>
        </svg>
    );
  };